/* istanbul ignore file */
import React from 'react';

import { useSelector } from '@lumapps/redux/react';

import { isUserDirectoryEditAllowed } from '../../ducks/selectors';
import { UserDirectoriesSettingsMenu as UserDirectoriesSettingsMenuUI } from './UserDirectoriesSettingsMenu';

export interface UserDirectoriesSettingsMenuContainerProps {
    scope: string;
}

export const UserDirectoriesSettingsMenu: React.FC<UserDirectoriesSettingsMenuContainerProps> = ({ scope }) => {
    const isAllowed = useSelector(isUserDirectoryEditAllowed);

    return <UserDirectoriesSettingsMenuUI isAllowed={isAllowed} scope={scope} />;
};
